// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BodyFileDescriptorBulkRestart
 */
export interface BodyFileDescriptorBulkRestart {
  /**
   *
   */
  dataType: string;
  /**
   *
   */
  projectId?: string | null;
}

/**
 * Check if a given object implements the BodyFileDescriptorBulkRestart interface.
 */
export function instanceOfBodyFileDescriptorBulkRestart(
  value: object
): value is BodyFileDescriptorBulkRestart {
  if (
    (!("dataType" in (value as Record<string, any>)) &&
      !("data_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataType"] === undefined &&
      (value as Record<string, any>)["data_type"] === undefined)
  )
    return false;
  return true;
}

export function BodyFileDescriptorBulkRestartFromJSON(json: any): BodyFileDescriptorBulkRestart {
  return BodyFileDescriptorBulkRestartFromJSONTyped(json, false);
}

export function BodyFileDescriptorBulkRestartFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BodyFileDescriptorBulkRestart {
  if (json == null) {
    return json;
  }
  return {
    dataType: json["data_type"],
    projectId:
      json["project_id"] === undefined
        ? undefined
        : json["project_id"] === null
        ? null
        : json["project_id"],
  };
}

export function BodyFileDescriptorBulkRestartToJSON(json: any): BodyFileDescriptorBulkRestart {
  return BodyFileDescriptorBulkRestartToJSONTyped(json, false);
}

export function BodyFileDescriptorBulkRestartToJSONTyped(
  value?: BodyFileDescriptorBulkRestart | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    data_type: value["dataType"],
    project_id: value["projectId"],
  };
}
